import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import AuditHistoryTable from "./auditHistoryTable";
import useHttp from "../../../hooks/useHttp";
import APIService from "../../../services/apiAxiosService";

function AuditHistory() {
  const [currentTab, setCurrentTab] = useState("1");
  const [reset, setReset] = useState(false);
  const [loading, setLoading] = useState(true);
  const [auditData, setAuditData] = useState([]);
  const { sendRequest: auditRoleAPI } = useHttp();

  const getAudits = async () => {
    await auditRoleAPI(APIService.getAuditsByRoleID(), (res) => {
      if (res.CODE) {
        setAuditData(res.MSG);
        setLoading(false);
      }
    });
  };

  useEffect(() => {
    getAudits();
  }, []);

  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setReset(!reset);
  };

  return (
    <div className="user-management-container">
      <Tabs
        defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="1" label="Audit History">
          <AuditHistoryTable AuditData={auditData} Loading={loading} />
        </Tab>
      </Tabs>
    </div>
  );
}
export default AuditHistory;
